import React from 'react';
import { Box, Typography, Divider, SxProps, Theme } from '@mui/material';
import { T } from '../../theme/tokens';

interface SynPanelProps {
    title?:     string;
    subtitle?:  string;
    action?:    React.ReactNode;
    children:   React.ReactNode;
    divider?:   boolean;
    sx?:        SxProps<Theme>;
    innerSx?:   SxProps<Theme>;
}

export function SynPanel({ title, subtitle, action, children, divider = true, sx, innerSx }: SynPanelProps) {
    return (
        <Box sx={{
            background: T.color.surface.white,
            borderRadius: `${T.radius.lg}px`,
            border: `1px solid ${T.color.border.light}`,
            boxShadow: T.shadow.card,
            overflow: 'hidden',
            ...(sx as object),
        }}>
            {(title || action) && (
                <>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 3, pt: 2.5, pb: divider ? 2 : 0,
                    }}>
                        <Box>
                            {title && (
                                <Typography sx={{
                                    fontSize: '0.875rem',
                                    fontWeight: 700,
                                    color: T.color.text.primary,
                                    letterSpacing: '-0.01em',
                                }}>
                                    {title}
                                </Typography>
                            )}
                            {subtitle && (
                                <Typography sx={{
                                    fontSize: '0.75rem',
                                    color: T.color.text.muted,
                                    mt: 0.25,
                                }}>
                                    {subtitle}
                                </Typography>
                            )}
                        </Box>
                        {action && <Box>{action}</Box>}
                    </Box>
                    {divider && <Divider sx={{ borderColor: T.color.border.light }} />}
                </>
            )}
            <Box sx={{ p: 3, ...(innerSx as object) }}>
                {children}
            </Box>
        </Box>
    );
}
